/**
 * ч.1105: підпис НЕЗВОРОТНОЇ дії ключем КЕП організації (видалення / передача
 * організації, видалення акаунта з підтвердженими організаціями).
 * Сервер видає одноразовий запит, привʼязаний до дії, акаунта, користувача і
 * організації; браузер підписує його зчитаним ключем САМЕ цієї організації
 * (ключ обирається за кодом ЄДРПОУ/РНОКПП); сервер криптоперевіряє підпис.
 * Ключ і пароль ключа не покидають браузер.
 */
import { accountOrgs, type KepAction } from '@/api/accountOrgs';
import { bytesToBase64, loadEuSign, pickKeyForCode, signDataInternal } from './eusign';

export async function signKepAction(
  action: KepAction, subject: string, orgCode: string, orgLabel: string,
  /** звідки взяти запит на підпис (за замовчуванням — запит поточного акаунта) */
  getChallenge: () => Promise<string> = () => accountOrgs.kepChallenge(action, subject),
): Promise<{ challenge: string; signature_b64: string }> {
  await loadEuSign();
  // Спершу ключ (помилка «немає зчитаного ключа цієї юрособи» — до звернення по запит).
  await pickKeyForCode(orgCode, orgLabel);
  const challenge = await getChallenge();
  const sig = signDataInternal(new TextEncoder().encode(challenge));
  return { challenge, signature_b64: bytesToBase64(sig) };
}
